export const skills = {
    en: [
        'C++',
        'PCB Design',
        'Java',
        'React',
        'TypeScript',
        'JavaScript',
        'HTML',
        'CSS / Tailwind',
        'Git',
    ],
    nl: [
        'C++',
        'PCB-ontwerp',
        'Java',
        'React',
        'TypeScript',
        'JavaScript',
        'HTML',
        'CSS / Tailwind',
        'Git',
    ]
};
